// extracted by mini-css-extract-plugin
export default {"imgAckStatusOverlay":"attendance-acknowledgement_imgAckStatusOverlay__2jCvK"};